<template>
  <div>
    <div>
      <!-- <div class="dashboard-content-inner my_custom_dash admin_extra_padding"> -->
        <!-- Dashboard Headline -->
        <!-- <div class="dashboard-headline heading_with_btn manage_job_mobile_hide">
          <h1>DP Jobs</h1>
          

         
        </div> -->
        <!-- <div class="dashboard-headline heading_with_btn manage_job_desktop_hide">
          <h1>DP Jobs</h1>
          
        </div> -->
        <!-- Row -->

        <div class="row">
          <!-- Dashboard Box -->
          <div class="col-xl-12">
            <div class="dashboard-box margin-top-0">
              <!-- Headline -->
              <!-- <div class="headline">
                <h3><i class="icon-material-outline-business-center"></i> DP Jobs</h3>
              </div> -->
              <!-- <div class="col-xl-12"> -->
              <div class="">
                  <iframe
                  :src="iframeUrl"
                  frameborder="0"
                  style="width: 100%; height: 800px;"
                  class="iframe_space"
                ></iframe>
      <!-- <iframe
  ref="iframe"
  :src="iframeUrl"
  style="width: 100%; height: 800px"
  @load="attachClickHandler"
/> -->

<Loader v-if="isIframeLoading" />
              </div>
              
            </div>
          </div>
        </div>
        
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import { POST_API } from "../../store/actions.type";
import permission from "../../../../server/permission.js";
import Bus from "../../event-bus";


export default {
  
  data() {
    return {
      webUrl: process.env.VUE_APP_URL,
    webUrlV1Admin: process.env.VUE_APP_URL_V1_Admin + "/admin-login",
    iframeUrl: '',
      actions: "",
    };
  },
  

  methods: {
     attachClickHandler() {
    const iframe = this.$refs.iframe;
    iframe.contentWindow.document.addEventListener('click', () => {
      this.isIframeLoading = true;
      Bus.$emit("showLoader");
      console.log('dddd')
      // fake timeout to auto-hide loader
      setTimeout(() => {
        this.isIframeLoading = false;
        Bus.$emit("hideLoader");
      console.log('ddddw')


      }, 2000); // adjust as needed
    });
  },
    
    permissionStaff() {
      if (this.$store.getters.getCurrentUserPermission) {
        if (
          this.$store.getters.getCurrentUserPermission.data.length > 0 &&
          this.$store.getters.currentUser.user_type_id == 2
        ) {
          var menu = this.$store.getters.getCurrentUserPermission.data;
          this.actions = permission.getPermissionStaff(menu, "DP Jobs Admin");
        }
      }
    },
    show(action) {
      if (this.$store.getters.currentUser.user_type_id == 2) {
        return this.actions.indexOf(action) >= 0 ? true : false;
      } else {
        return true;
      }
    },
  },
  mounted() {
    $('.tip_img').hide();
    this.logged_in_user_id =
      this.$store.getters.currentUser != null ? this.$store.getters.currentUser.id : "";
    
    this.permissionStaff();
    // this.iframeUrl = process.env.VUE_APP_URL_V1_Admin + "/admin-login"
    this.iframeUrl = process.env.VUE_APP_URL_V1_Admin + "/admin/jobs/manageJobsAdmin"
    // this.iframeUrl = 'http://localhost:8080/v2/admin/per-hour-cost'

    $(".dashboard-content-container .simplebar-scroll-content").animate(
      {
        scrollTop: 0,
      },
      "fast"
    );

    //  Bus.$on("showLoader", () => {
    //   this.isLoading = true;
    // });

    // Bus.$on("hideLoader", () => {
    //   this.isLoading = false;
    // });
  },
};
</script>
